import { CellCultivoComponent } from './cell-cultivo/cell-cultivo.component';
import { CellDatepickerComponent } from './cell-datepicker/cell-datepicker.component';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { VisorFirebaseService } from 'app/services/visor-firebase.service';
import * as moment from 'moment';
import { LocalDataSource } from 'ng2-smart-table';
import { ActivatedRoute, Router } from '@angular/router';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import {UNIDADES} from './constantes-diario';
import { CellUnidadComponent } from './cell-unidad/cell-unidad.component';
import listadoProductos from '../../listados/productos.json';
import { R } from '@angular/cdk/keycodes';
import { VisorRecord } from 'app/services/beans/Record';

@Component({
  selector: 'visor-diario',
  templateUrl: './visor-diario.component.html',
  styleUrls: ['./visor-diario.component.scss']
})
export class VisorDiarioComponent implements OnInit {

  @ViewChild('deleteconfirmation')
  private deleteDialog: TemplateRef<any>;

  parcelas: any[];
  selectedParcela: any[];
  selectedRecordType: any[];
  selectedPropietario: any[];
  selectedRegistro: any;
  recordTypes = [
    {
      "identifier": "SIEMBRA",
      "name": "Siembra"
    },
    {
      "identifier": "FERTILIZACION",
      "name": "Fertilización"
    },
    {
      "identifier": "TRATAMIENTO",
      "name": "Tratamiento fitosanitario"
    },
    {
      "identifier": "COSECHA",
      "name": "Cosecha"
    },
    {
      "identifier": "GEOFOTO",
      "name": "Geofoto"
    }
  ];
  diario: VisorRecord[];
  parcelaSelected: any = '';
  productos = listadoProductos;
  seasons = [];



  source: LocalDataSource = new LocalDataSource();
  pagedResult: import("../../services/firebase-component").FirebasePaged;

  forceToRefreshRecordList: boolean = false;

  public vUser: string = "";
  public vGroupUsers: any = [];

  constructor(protected visorFirebaseService: VisorFirebaseService,
    private route: ActivatedRoute,
    private router: Router,
    private nbToastr: NbToastrService,
    private dialogService: NbDialogService) { }

  ngOnInit(): void {
    this.visorFirebaseService.getUser().subscribe((user) =>{
      console.log ("TEnemos usuario")
      if (user) {
        console.log(user)
        this.vUser = user.uid;

        this.visorFirebaseService.groupUsers$.subscribe((groupUsers) => {
          this.vGroupUsers = groupUsers;
        });
        this.visorFirebaseService.obtenerParcelas().subscribe((parcelas) => {
          // console.log("Tenemos parcelas")
          //  console.log(JSON.stringify(parcelas));
          this.parcelas = parcelas.map(p =>{
            p.newAlias = p.alias;
            if(p.campania == null) p.campania = {};
            return p;
          });



          this.route.paramMap.subscribe((params) => {
            if(params.get('fieldId')){
              this.cargarDiario(params.get('fieldId'));
            }

          })
        });
        this.cargarTemporadas();
        this.resetFilter();

      }else{
        this.router.navigate(['pages','visor']);
      }

    });
  }

  getGroupUserEmail(userOwnerId: string): string {
    const groupUser = this.vGroupUsers?.find(user => user.id === userOwnerId);
    return groupUser ? groupUser.email : '';
  }

  cargarTemporadas(){
    this.visorFirebaseService.obtenerSeasons().subscribe(seasons => this.seasons = seasons);
  }

  cargarDiario(idParcela: string){
    this.parcelaSelected = idParcela;
      this.visorFirebaseService.obtenerDiario(idParcela).subscribe((diario) => {
          this.diario = diario;
         // console.log(this.diario);

      });
  }

  actualizaCuaderno(){
    /*
    this.visorFirebaseService.obtenerRegistrosCuaderno().then(registros => {
      this.diario = registros;
    });
    */
  }

  cambioListadoParcelas(event: boolean){
    console.log("Cambia el estado del listado de parcelas "+event);
  }

  borrarDiario(event:any){
      // console.log("Queremos borrar el diario");
      this.dialogService.open(this.deleteDialog,{context:{evento:event}});

  }

  editarDiario(event:any){
    // console.log(event);
    this.visorFirebaseService.actualizaRegistroDiario(this.parcelaSelected,event.newData).subscribe((confirmado) =>{
      // console.log(confirmado)
      event.confirm.resolve(event.newData);
    })
  }

  crearDiario(event:any){
    //console.log(this.parcelaSelected)
    //console.log(event);
    if(this.source.count()>2){
        //Debemos verificar si es premium
        this.visorFirebaseService.checkPremium().subscribe((premium) => {
          if (premium){
            this.visorFirebaseService.creaRegistroDiario(this.parcelaSelected, event.newData).subscribe((newRegistro)=>{
              event.confirm.resolve(newRegistro);
            });
          }else{
            //NO ES PREMIUM
            event.confirm.reject();
            this.nbToastr.danger('Para realizar esta operación necesita ser usuario premium','Operacion no permitida');

          }
        })
    }else{
      this.visorFirebaseService.creaRegistroDiario(this.parcelaSelected, event.newData).subscribe((newRegistro)=>{
        event.confirm.resolve(newRegistro);
      });
    }

  }

  confirmarEliminar(event:any){
    //console.log(event);
    this.visorFirebaseService.eliminarRegistroDiario(this.parcelaSelected,event.data.id).subscribe((confirmado)=>{
      event.confirm.resolve();
    })
  }

  confirmarCrear(event:any){

    if(this.source.count()>1){

    }
  }


  guardarParcela(parcela:any){

      let p = JSON.parse(JSON.stringify(parcela));

      p.alias = parcela.newAlias;
      delete p.newAlias;
      p.campania.campania = this.seasons.find(s => s.identifier === p.campania.campaniaRef).name;
      p.campania.cultivo = this.productos.find(pr => pr.identifier == p.campania.codCultivo).name;
      this.visorFirebaseService.updateParcela(p).subscribe((confirmado) => {
        console.log("Actualizado")
        let index = this.parcelas.indexOf(this.parcelas.find(pr => pr.id === parcela.id));
        console.log(index);
        this.parcelas[index] = p;
        console.log(this.parcelas);
      });

  }


  updateRecordsFilter(event){
    this.diario = [];
    console.log('Vamos a actualizar el filtro');
    this.pagedResult = this.visorFirebaseService.obtenerRegistros(this.selectedParcela,this.selectedRecordType,this.selectedPropietario);
    this.pagedResult.observe().subscribe((registros) => {

        console.log('Obtenemos datos');
        this.diario = this.diario.concat(registros);
        this.forceToRefreshRecordList = this.diario.length == 0;
    });
    if(this.forceToRefreshRecordList) this.pagedResult.refresh();
  }


  resetFilter(){
    this.selectedParcela=[];
    this.selectedRecordType=[];
    this.selectedPropietario=[];
    this.updateRecordsFilter(null);
  }

  loadNextRegistros(){
    if(this.pagedResult != undefined){
      this.pagedResult.refresh();
    }
  }


  editarRegistro(item){
    this.selectedRegistro = Object.assign({}, item);
  }


  deleteRegistro(item){
    console.log('Queremos borrar el registro '+item);
    this.visorFirebaseService.eliminarRegistro(item).then(() => {
      this.selectedRegistro = null;
      this.updateRecordsFilter(null);
    });

  }

  updateRegistro(item){



    console.log(`Queremos actualizar el registro ${item}`);
    this.visorFirebaseService.guardarRegistro(item).then(() => {
      this.selectedRegistro = null;
      this.updateRecordsFilter(null);
    });
  }
}
